import { React } from 'react';
import { Tooltip } from '@chakra-ui/react';
import { motion } from 'framer-motion';

/*
 * Compact flame + count shown next to a habit. Pops in with a spring whenever
 * the count changes. A repairable streak (yesterday missed, still fixable via
 * the date navigation) is shown muted with a repair hint instead of being
 * hidden — a streak the user can still save is motivating, a lost one isn't.
 */
function StreakBadge({ streak }) {
  if (!streak || streak.count < 2 || streak.status === 'none') return null;
  const paused = streak.status === 'repairable';
  const label = paused
    ? 'Streak paused — check in yesterday to keep it going'
    : `${streak.count} days in a row`;

  return (
    <Tooltip label={label} hasArrow>
      <motion.span
        key={`${streak.count}-${streak.status}`}
        initial={{ scale: 0.4, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 500, damping: 20 }}
        aria-label={label}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          fontSize: '0.85em',
          fontWeight: 600,
          color: paused ? '#a0aec0' : '#dd6b20',
          filter: paused ? 'grayscale(1)' : 'none',
          whiteSpace: 'nowrap',
        }}
      >
        🔥{streak.count}
      </motion.span>
    </Tooltip>
  );
}

export { StreakBadge };
